// "Spot the Slip" expansion — IDENTITY theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_IDENTITY = [
  ["La mia amica sta malata oggi.", "La mia amica è malata oggi.", "essere-stare",
    "Being ill is expressed with essere in Italian → è malata.", "essere-vs-stare"],
  ["Come sei oggi? Tutto bene?", "Come stai oggi? Tutto bene?", "essere-stare",
    "Asking how someone feels uses stare → come stai.", "essere-vs-stare"],
  ["Lui è di Napoli ed è napoletano.", "Lui è di Napoli ed è napoletano.", "essere-stare",
    "Trap check: origin and identity both use essere. (Already correct!)", "essere-vs-stare"],
  ["La ragazza è molto simpatico.", "La ragazza è molto simpatica.", "agreement",
    "Adjectives agree with the noun: feminine subject → simpatica.", "adjective-agreement"],
  ["È una uomo alto.", "È un uomo alto.", "gender",
    "Uomo is masculine; pair it with un, not una.", "gender-of-nouns"],
  ["Mia sorella è molto generoso.", "Mia sorella è molto generosa.", "agreement",
    "A feminine subject needs the feminine form generosa.", "adjective-agreement"],
  ["Mi piace le persone gentili.", "Mi piacciono le persone gentili.", "piacere",
    "Piacere agrees with the thing liked; plural people → piacciono.", "piacere-and-similar-verbs"],
  ["Ieri mio nonno moriva dopo una lunga vita.", "Ieri mio nonno è morto dopo una lunga vita.", "passato-imperfetto",
    "A single, completed event takes the passato prossimo → è morto.", "passato-prossimo-vs-imperfetto"],
  ["Da giovane sono stato sempre timido.", "Da giovane ero sempre timido.", "passato-imperfetto",
    "An ongoing trait in the past is imperfetto → ero.", "passato-prossimo-vs-imperfetto"],
  ["Sono cresciuto a Roma e ho diventato grande lì.", "Sono cresciuto a Roma e sono diventato grande lì.", "auxiliary",
    "Diventare takes essere in compound tenses → sono diventato.", "compound-tenses-and-auxiliaries"],
  ["Il mio carattere è tranquillo.", "Il mio carattere è tranquillo.", "gender",
    "Trap check: carattere is masculine. (Already correct!)", "gender-of-nouns"],
  ["Voglio che mio figlio è educato.", "Voglio che mio figlio sia educato.", "congiuntivo",
    "A wish about someone else (volere che) triggers the subjunctive → sia.", "congiuntivo-presente"],
  ["È importante che tu sei onesto.", "È importante che tu sia onesto.", "congiuntivo",
    "Impersonal 'è importante che' takes the subjunctive → sia.", "congiuntivo-presente"],
  ["Il mio nome? Te lo dico il mio nome.", "Il mio nome? Te lo dico.", "pronoun-order",
    "Don't restate 'il mio nome' after the object pronoun lo.", "object-pronouns"],
  ["Sono molto bene, grazie.", "Sto molto bene, grazie.", "essere-stare",
    "Well-being uses stare → sto bene.", "essere-vs-stare"],
];
